import React from "react";
import Profile from "../../assets/images/Mohanraj.png";

function ProfileImage() {
  return (
    <div>
      <img src={Profile} alt="mohanrajProfileImage" />
    </div>
  );
}

export default ProfileImage;
